import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    return value == null || value.length === 0
      ? ''
      : value.length === 1
      ? value.toLocaleUpperCase()
      : this.doCapitalize(value);
  }

  private doCapitalize(value: string): string {
    const nonWhiteSpaceIndex = value.search(/\S/);
    return (
      value.slice(0, nonWhiteSpaceIndex + 1).toLocaleUpperCase() +
      value.slice(nonWhiteSpaceIndex + 1)
    );
  }
}
